"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MyInformation = void 0;
var _mui = require("@ori-ui/mui");
var _emailManager = require("@ori/email-manager");
var _phoneManager = require("@ori/phone-manager");
var _shoppingContext = require("@ori/shopping-context");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../hooks");
var _models = require("../../models");
var _skeletons = require("../skeletons");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const MyInformation = ()=>{
    const { getTestIdProps } = (0, _testidGenerator.default)();
    const { formatMessage } = (0, _hooks.useTranslations)();
    const urlParams = new URLSearchParams(window.location.search);
    const store = urlParams.get('store');
    const profileLink = store ? "/mypages/profile?store=".concat(store, "#/contact") : '/mypages/profile';
    const { isLoading, shoppingContext: { customerId, shoppingBagOwnerName = '' } = {} } = (0, _shoppingContext.useShoppingContext)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.MyInformationWrapper, {
        ...getTestIdProps(_models.TestId.MyInformation),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.SectionHeader, {
                ...getTestIdProps(_models.TestId.MyInformationHeader),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                    variant: "h6",
                    component: "h2",
                    ...getTestIdProps(_models.TestId.MyInformationTitle),
                    children: formatMessage('myInformation')
                })
            }),
            isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_skeletons.MyInformationSkeleton, {}) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.MyInformationContent, {
                children: [
                    shoppingBagOwnerName ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                        fontWeight: "bold",
                        ...getTestIdProps(_models.TestId.MyInformationName),
                        children: shoppingBagOwnerName
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_phoneManager.PhoneInputManager, {
                        currentCustomerId: customerId,
                        sectionType: _phoneManager.SectionType.Checkout
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_emailManager.EmailManager, {
                        currentCustomerId: customerId,
                        sectionType: _emailManager.SectionType.Checkout,
                        customInputMaxWidth: "100%"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.MyInformationChangeMessage, {
                        variant: "body1",
                        ...getTestIdProps(_models.TestId.MyInformationChange),
                        children: [
                            formatMessage('needToMakeAChange'),
                            ' ',
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Link, {
                                href: profileLink,
                                children: formatMessage('goToYourProfileSettings')
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
exports.MyInformation = MyInformation;
